import { render, staticRenderFns } from "./deleteMatchModal.vue?vue&type=template&id=76783aad&scoped=true"
import script from "./deleteMatchModal.vue?vue&type=script&lang=js"
export * from "./deleteMatchModal.vue?vue&type=script&lang=js"
import style0 from "./deleteMatchModal.vue?vue&type=style&index=0&id=76783aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76783aad",
  null
  
)

export default component.exports